import axios from '@/lib/axios';
import { useQueries, useQuery } from '@tanstack/react-query';
import { Pager, PurchaseOrder, TeamPurchaseOrderPhase, UserInvitation, Workspace } from '@/hooks/api/models';
import queryClient from '@/lib/queryClient';
import { queries } from '@testing-library/react';

/**
 * 0520. 発注案件一覧
 * [GET] /workspaces/:identifier/teams/:team_id/purchase_orders
 */
type Props = {
  identifier: string;
  team_id: number;
  page: number;
  per: number;
  team_purchase_order_phase_ids?: number[];
  user_ids?: number[];
  business_partner_ids?: number[];
  payment_method_ids?: number[];
  payment_context_ids?: number[];
  my_project?: boolean;
  archived?: boolean;
  enabled?: boolean;
};

export type PurchaseOrdersResponse = {
  purchase_orders: PurchaseOrder[];
  pager: Pager;
};
const purchase_orders = (props: Props): Promise<PurchaseOrdersResponse> => {
  return axios.get(`/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders`, { params: props });
};

export const usePurchaseOrders = (props: Props) => {
  return useQuery({
    queryKey: [
      'workspaces',
      props.identifier,
      'teams',
      props.team_id,
      'purchase_orders',
      'pager',
      props.page,
      props.per,
      props.team_purchase_order_phase_ids,
      props.user_ids,
      props.business_partner_ids,
      props.payment_method_ids,
      props.payment_context_ids,
      props.my_project,
      props.archived,
    ],
    queryFn: () => purchase_orders(props),
    enabled: props.enabled,
  });
};

export const usePurchaseOrdersPerPhase = (phases: TeamPurchaseOrderPhase[], props: Props) => {
  return useQueries({
    queries: phases
      ? phases.map((phase) => {
          const params = { ...props, team_purchase_order_phase_ids: [phase.id] };
          return {
            queryKey: [{ ...params }],
            queryFn: () => purchase_orders(params),
          };
        })
      : [],
  });
};

export const usePurchaseOrdersInvalidate = (identifier: string, team_id: number) => {
  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: ['workspaces', identifier, 'teams', team_id, 'purchase_orders'] });
  };

  return { invalidate };
};
